<template>
  <v-container fluid>
    <patient-header />
    <v-card class="mt-5 mb-10">
      <v-card-text>
        <v-row no-gutters justify="space-between">
          <v-col cols="12" sm="3" class="mr-3">
            <DateRangePicker v-model="filter.date" @input="load" />
          </v-col>
          <v-col cols="auto">
            <v-btn :to="{ name: 'total-monthly-report' }" color="primary">Итоговый отчет</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <template v-if="items.length">
      <v-card v-for="item in items" :key="item.id" class="mb-5">
        <v-card-title class="text-h3">
          {{ item.last_name }} {{ item.first_name }} {{ item.middle_name }}&nbsp;
          <span title="Логин пациента"> - {{ item.login }}</span>
          <!--
          <a
            :href="`${projectUrl}/?customer_id=${item.id}&doctor_id=${item.id}#/documents`"
            target="_blank"
            class="text-decoration-none"
          >
            Отчеты о психофизиологическом состоянии сотрудника
          </a>
          -->
        </v-card-title>

        <v-card-text>
          <div>
            <v-card v-if="isIndexOfTheResult" class="mb-5">
              <v-card-title class="text-h4">Количество превышений индекса результата по датам</v-card-title>
              <v-card-text>
                <GroupLegendIndexOfTheResult />
              </v-card-text>
              <IkpMedParamsExcessMeasurementChart v-if="item.excess.length" :items="item.excess" :height="200" />
              <v-card-text v-else>Данных нет</v-card-text>
            </v-card>

            <v-card v-if="isIndexOfHealth" class="mb-5">
              <v-card-title class="text-h4">Количество превышений индекса работоспособности по датам</v-card-title>
              <v-card-text>
                <GroupLegendIndexOfHealth />
              </v-card-text>
              <IndexOfHealthChart v-if="item.excess.length" :items="item.excess" :height="200" />
              <v-card-text v-else>Данных нет</v-card-text>
            </v-card>

            <v-card class="mb-5">
              <v-card-title class="text-h4">Средние значения параметров по датам</v-card-title>
              <IkpMedParamsAverageMeasurementChart v-if="item.average.length" :items="item.average" :height="200" />
              <v-card-text v-else>Данных нет</v-card-text>
            </v-card>
          </div>
        </v-card-text>
      </v-card>

      <v-card>
        <v-data-table :headers="groupHeaders" :items="groups" :loading="loading" :items-per-page="-1">
          <template v-slot:item.date="{ item }">
            <div v-if="item.created_at">
              {{ $date(item.created_at).format("DD.MM.YYYY") }}
            </div>
          </template>

          <template v-slot:item.doctor="{ item }">
            <div v-if="item.doctor">
              {{ item.doctor.user_last_name }} {{ item.doctor.user_first_name }} {{ item.doctor.user_middle_name }}
            </div>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <div v-else>
      Данных нет
    </div>
  </v-container>
</template>

<script>
import PatientHeader from "@/components/PatientHeader";
import IkpMedParamsExcessMeasurementChart from "@/views/pages/ikp/components/IkpMedParamsExcessMeasurementChart.vue";
import IkpMedParamsAverageMeasurementChart from "@/views/pages/ikp/components/IkpMedParamsAverageMeasurementChart.vue";
import DateRangePicker from "@/components/forms/DateRangePicker.vue";
import GroupLegendIndexOfTheResult from "@/views/pages/group-conclusion/GroupLegendIndexOfTheResult.vue";
import { INDEX_OF_HEALTH, INDEX_OF_THE_RESULT } from "@/views/pages/group-conclusion/med-params.config.js";
import GroupLegendIndexOfHealth from "@/views/pages/group-conclusion/GroupLegendIndexOfHealth.vue";
import IndexOfHealthChart from "@/views/pages/group-conclusion/IndexOfHealthChart.vue";
import { FLAGS } from "@/configs/index.js";

export default {
  components: {
    IndexOfHealthChart,
    GroupLegendIndexOfHealth,
    GroupLegendIndexOfTheResult,
    DateRangePicker,
    IkpMedParamsAverageMeasurementChart,
    IkpMedParamsExcessMeasurementChart,
    PatientHeader,
    PatientHeader,
  },

  data() {
    return {
      loading: false,
      filter: {
        date: [],
      },
      groups: [],
      items: [],
      medParam: null,
      groupHeaders: [
        {
          text: "Дата",
          align: "start",
          sortable: false,
          value: "date",
        },
        {
          text: "Доктор",
          align: "start",
          sortable: false,
          value: "doctor",
        },
        {
          text: "Заключение",
          align: "start",
          sortable: false,
          value: "recommendation",
        },
      ],
    };
  },

  computed: {
    domainName() {
      return window.location.host.split("-")[0];
    },

    projectUrl() {
      // return "http://localhost:8080";
      return `https://${this.domainName}-patient-management.healthkeeper.ru`;
    },

    isIndexOfTheResult() {
      return INDEX_OF_THE_RESULT === this.medParam;
    },

    isIndexOfHealth() {
      return INDEX_OF_HEALTH === this.medParam;
    },
  },

  async created() {
    await this.load();
  },


  methods: {
    async load() {
      const measurementReportUrlFlag = this.$featureFlags.feature(FLAGS.MEASUREMENT_REPORT_URL);

      if (!measurementReportUrlFlag.enabled) {
        alert("Флаг measurementReportUrlFlag отключен");
        return;
      }

      if (!measurementReportUrlFlag.value) {
        alert("Url для загрузки отчетов не задан");
        return;
      }

      let customersList = [];

      try {
        const { data } = await this.$http.get("/v1/customers", {
          params: {
            group_conclusion_participant: 1,
            limit: 1000,
          },
        });

        customersList = data?.data || [];
      } catch (error) {
        alert(error);
      }

      if (customersList.length === 0) {
        alert("ИД пользователей не переданы");
        return;
      }

      try {
        const { data } = await this.$http.get(`/v1/group-conclusion/measurement-report/${measurementReportUrlFlag.value}`, {
          params: {
            customers: customersList.map(customer => customer.id),
            date: this.filter.date,
          },
        });

        this.items = data.data ?? [];
        this.medParam = String(data.med_param);
      } catch (e) {
        console.log(e);
      }

      try {
        const { data } = await this.$http.get(`v1/group-conclusion`, {
          params: {
            date: this.filter.date,
          },
        });

        this.groups = data.data ?? [];
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
